module.exports = __webpack_public_path__ + "snap_ai.png?2f2590a72f9a14f68364d387e77b2246";